import React from "react";
import { RaisedButton, TextField } from "material-ui";

export const ArticleRow = (props) => {
  return (
    <tr>
      {props.yearId && props.createdYear && props.article.orderId ? (
        <td>
          {props.yearId + "/" + props.createdYear + "/" + props.article.orderId}
        </td>
      ) : (
        <td />
      )}

      <td>{props.article.product.name}</td>

      {/*<td>{props.article.details}</td>*/}
      {props.editable ? (
        <td>
          <TextField
            style={{ width: 200 }}
            hintText="Detalii"
            type={"text"}
            value={props.article.details}
            rowsMax={2}
            onChange={(e) => props.onDetailChanged(e, props.index)}
          />
        </td>
      ) : (
        <td>
          <div
            style={{
              maxWidth: "200px",
              wordWrap: "break-word",
              textAlign: "left",
            }}
          >
            {props.article.details}
          </div>
        </td>
      )}

      {(props.canEditPapers && props.canUserApprove) || props.editable ? (
        <td>
          <TextField
            type="number"
            errorText={
              props.article.error && props.article.error.pricePerUnit
                ? props.article.error.pricePerUnit
                : null
            }
            value={props.article.pricePerUnit}
            onChange={(e) => props.onPricePerUnitChanged(e, props.index)}
          />
        </td>
      ) : (
        <td>{props.article.pricePerUnit}</td>
      )}

      {props.editable ? (
        <td>
          <TextField
            type="number"
            errorText={
              props.article.error && props.article.error.vat
                ? props.article.error.vat
                : null
            }
            value={props.article.vat}
            onChange={(e) => props.onVatChanged(e, props.index)}
          />
        </td>
      ) : (
        <td>{props.article.vat + "%"}</td>
      )}

      {(props.canEditPapers && props.canUserApprove) || props.editable ? (
        <td>
          <TextField
            type="number"
            errorText={
              props.article.error && props.article.error.quantity
                ? props.article.error.quantity
                : null
            }
            value={props.article.quantity}
            onChange={(e) => props.onQuantityChanged(e, props.index)}
          />
        </td>
      ) : (
        <td>{props.article.quantity}</td>
      )}

      {props.canSetArticolBugetar && props.canUserApprove ? (
        <td>
          <TextField
            type="text"
            errorText={
              props.article.error && props.article.error.articolBugetar
                ? props.article.error.articolBugetar
                : null
            }
            value={props.article.articolBugetar}
            onChange={(e) => props.onArticolBugetarChange(e, props.index)}
          />
        </td>
      ) : (
        <td>{props.article.articolBugetar}</td>
      )}

      <td>
        {props.editable && props.articlesSize > 1 && (
          <RaisedButton
            secondary
            label={"Sterge"}
            onClick={() => props.onDeleteClicked(props.index, props.article)}
          />
        )}
      </td>
    </tr>
  );
};
